<template>
  <div>
    <form @submit.prevent="handleSubmit(!v$.$invalid)">
      <div class="formgrid grid">
        <div class="field col-12 md:col-6">
          <label :class="{ 'p-error': v$.form.bank.$invalid && submitted }"
            >Bank *</label
          >
          <InputText
            v-model="form.bank"
            :class="{ 'p-invalid': v$.form.bank.$invalid && submitted }"
            type="text"
            class="w-full"
          />
          <small
            v-if="
              (v$.form.bank.$invalid && submitted) ||
              v$.form.bank.$pending.$response
            "
            class="p-error"
            >{{ v$.form.bank.required.$message }}</small
          >
        </div>
        <div class="field col-12 md:col-6">
          <label :class="{ 'p-error': v$.form.cabang.$invalid && submitted }"
            >Cabang *</label
          >
          <InputText
            v-model="form.cabang"
            :class="{ 'p-invalid': v$.form.cabang.$invalid && submitted }"
            type="text"
            class="w-full"
          />
          <small
            v-if="
              (v$.form.cabang.$invalid && submitted) ||
              v$.form.cabang.$pending.$response
            "
            class="p-error"
            >{{ v$.form.cabang.required.$message }}</small
          >
        </div>
        <div class="field col-12 md:col-6">
          <label :class="{ 'p-error': v$.form.nama.$invalid && submitted }"
            >Pemilik Rekening *</label
          >
          <InputText
            v-model="form.nama"
            :class="{ 'p-invalid': v$.form.nama.$invalid && submitted }"
            type="text"
            class="w-full"
          />
          <small
            v-if="
              (v$.form.nama.$invalid && submitted) ||
              v$.form.nama.$pending.$response
            "
            class="p-error"
            >{{ v$.form.nama.required.$message }}</small
          >
        </div>
        <div class="field col-12 md:col-6">
          <label :class="{ 'p-error': v$.form.rekening.$invalid && submitted }"
            >No. Rekening *</label
          >
          <InputText
            v-model="form.rekening"
            :class="{ 'p-invalid': v$.form.rekening.$invalid && submitted }"
            type="text"
            class="w-full"
          />
          <small
            v-if="
              (v$.form.rekening.$invalid && submitted) ||
              v$.form.rekening.$pending.$response
            "
            class="p-error"
            >{{ v$.form.rekening.required.$message }}</small
          >
        </div>
      </div>
      <div class="flex justify-content-end align-items-end">
        <Button
          :loading="loading"
          label="Simpan"
          icon="pi pi-check"
          type="submit"
        />
      </div>
    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { helpers, required } from '@vuelidate/validators'

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      submitted: false,
    }
  },
  computed: {
    title() {
      return this.item && this.item.id === 0
        ? 'Tambah Rekening'
        : 'Edit Rekening'
    },
    form() {
      return this.item
    },
  },
  methods: {
    handleSubmit(isFormValid) {
      this.submitted = true
      if (!isFormValid) {
        return
      }
      this.$emit('save', this.form)
    },
  },
  validations() {
    return {
      form: {
        bank: {
          required: helpers.withMessage('Bank harus diisi.', required),
        },
        cabang: {
          required: helpers.withMessage('Cabang harus diisi.', required),
        },
        nama: {
          required: helpers.withMessage(
            'Nama pemilik rekening harus diisi.',
            required
          ),
        },
        rekening: {
          required: helpers.withMessage('No. Rekening harus diisi.', required),
        },
      },
    }
  },
}
</script>
